<div class="main">
  <div class="header" (click)="navigation.home()">
    <img class="logo" src="assets/flagge_black.png">
  </div>

  <div class="scrollable">

    <div class="stage">
      <router-outlet></router-outlet>
    </div>

    <app-footer style="display: block;flex-shrink: 0;"></app-footer>

  </div>
</div>
